import { render, staticRenderFns } from "./LoginProduct.vue?vue&type=template&id=6c0234be&scoped=true&"
import script from "./LoginProduct.vue?vue&type=script&lang=js&"
export * from "./LoginProduct.vue?vue&type=script&lang=js&"
import style0 from "./LoginProduct.vue?vue&type=style&index=0&id=6c0234be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0234be",
  null
  
)

export default component.exports